module.exports = __webpack_public_path__ + "media/images/badge-fullcolor-alpha__150x150-30ecb749fc357e9dd15e936417d1db99.png";